import { render, staticRenderFns } from "./CareLabelForm.vue?vue&type=template&id=be76fa2a&scoped=true"
import script from "./CareLabelForm.vue?vue&type=script&lang=js"
export * from "./CareLabelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be76fa2a",
  null
  
)

export default component.exports